import gql from "graphql-tag";

export const LOGIN_USER = gql`
    mutation login(
        $username: String!
        $password: String!
    ) {
        login(
            input: {
                username: $username
                password: $password
            }
        ) {
            access_token
            user {
                id
                name
                email
                must_change_password
            }
        }
    }
`;
export const REGISTER_USER = gql`
    mutation register(
        $name: String!
        $email: String!
        $password: String!
        $password_confirmation: String!
    ) {
        register(
            input: {
                name: $name
                email: $email
                password: $password
                password_confirmation: $password_confirmation
            }
        ) {
            tokens {
                access_token
            }
        }
    }
`;